import { default as RadarChart } from './RadarChart';

export default RadarChart;
